import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-401def30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body position-absolute bottom-0 start-50 translate-middle-x" }
const _hoisted_2 = {
  key: 0,
  class: "card-title"
}
const _hoisted_3 = {
  key: 1,
  class: "card-text"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1))

import { Iempresa } from '@/app/model/empresa';
import { PropType } from 'vue'
import router from '@/router';

export default /*#__PURE__*/_defineComponent({
  __name: 'CardEmpresas',
  props: {
    empresa: {type:Object as PropType<Iempresa>},
},
  setup(__props) {

_useCssVars(_ctx => ({
  "6dbea2b2": (__props.empresa?.colorButon),
  "29eb2b3b": (__props.empresa?.textcolorbtn),
  "5583427c": (__props.empresa?.secondaryColorButon),
  "2ed59781": (__props.empresa?.textcolor)
}))


const props=__props

const goToPage =()=>{
    router.push({name:props.empresa?.name!});
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "card bg-image row align-items-end",
    style: _normalizeStyle({ backgroundImage: 'url(' + require('@/assets/img/' + __props.empresa?.img) + ')' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.empresa?.title)
        ? (_openBlock(), _createElementBlock("h5", _hoisted_2, _toDisplayString(__props.empresa?.title), 1))
        : _createCommentVNode("", true),
      (__props.empresa?.subtitle)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.empresa?.subtitle), 1))
        : _createCommentVNode("", true),
      _createElementVNode("a", {
        onClick: goToPage,
        class: "btn btn-primary"
      }, [
        _createTextVNode("CONÓCENOS "),
        _hoisted_4
      ])
    ])
  ], 4))
}
}

})